export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10899.f38754f8.jpg";